import { atom } from 'jotai';

import type { LeadType } from '@lead-forms/Entities/LeadType.entity';

export const leadFormIdAtom = atom<LeadType | ''>('');
